import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import { Link, useLocation, useRouteMatch } from "react-router-dom";
import clsx from "clsx";
import { Box } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import DashboardIcon from "@material-ui/icons/Dashboard";
import CreatorHeaderLogo from "./CreatorHeaderLogo";

const useStyles = makeStyles(theme => ({
  home: {
    height: 44,
    width: 44,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    textAlign: "center",
    borderRadius: 12,
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.contrastText,
    "&:hover": {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
  },

  placeholder: {
    width: 44,
    height: 44,
  },

  selectedTab: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.contrastText,
    },
  },

  homeIcon: {
    fontSize: "2.2rem",
  },
}));

const CreatorNavigation = () => {
  const { url } = useRouteMatch();
  const location = useLocation();
  const classes = useStyles();

  const tabs = {
    home: `${url}/home`,
  };

  return (
    <Box>
      <Grid container alignItems="center" justify="space-between">
        <Grid item>
          {location.pathname !== "/creator/home" ? (
            <Link role="tab" to={tabs.home}>
              <Box
                className={clsx(classes.home, {
                  [classes.selectedTab]: location.pathname.startsWith(
                    tabs.home,
                  ),
                })}
              >
                <DashboardIcon
                  fontSize="large"
                  classes={{ fontSizeLarge: classes.homeIcon }}
                />
              </Box>
            </Link>
          ) : (
            <Box className={classes.placeholder} />
          )}
        </Grid>

        <Grid item sm>
          <CreatorHeaderLogo />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CreatorNavigation;
